import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Container, Row, Button } from "@/Components/Common/Tailwind";

import { FooterModal, FooterSnsEditModal, FooterSnsAddModal } from "../../../Components/modal/ManagerModal";
import { useUserStore } from "../../../store/store";
import { getLegalDocumentHref, isExternalLegalHref } from "../../Legal/legalDocuments";

const Footer = (props) => {
  const navigate = useNavigate();

  const [visibleFooterEditModal, setVisibleFooterEditModal] = React.useState(false);
  const [visibleFooterSnsEditModal, setVisibleFooterSnsEditModal] = React.useState(false);
  const [visibleFooterSnsAddModal, setVisibleFooterSnsAddModal] = React.useState(false);

  const siteInfo = useUserStore((state) => state.site);
  const siteDetail = useUserStore((state) => state.siteDetail);
  const [snsLinkList, setSnsLinkList] = React.useState(siteInfo?.sns_links || []);
  const legalSite = siteDetail || siteInfo;
  const servicePolicyHref = getLegalDocumentHref("service-policy", legalSite);
  const privacyPolicyHref = getLegalDocumentHref("privacy-policy", legalSite);

  if (!siteInfo) {
    return null;
  }

  return (
    <React.Fragment>
      <footer className="custom-footer  position-relative " style={{ borderTop: "1px solid #e5e7eb", marginTop: "100px", paddingBottom: "70px" }}>
        <Container>
          <Row style={{ marginTop: "20px" }}>
            <Col lg={8} className="">
              <div>
                <div dangerouslySetInnerHTML={{ __html: siteInfo.footer }} style={{ fontFamily: "Gmarket-M", lineHeight: "28px", color: "#404040" }} />
                {/* <div>{!!props.permission && props.permission.permission}</div> */}
              </div>
              {!!props.permission && props.permission.permission > 0 ? (
                <Button className="btn-soft-warning mb-3 position-absolute top-50 end-0" style={{ color: "#404040" }} onClick={() => setVisibleFooterEditModal(!visibleFooterEditModal)}>
                  footer 내용 수정하기
                </Button>
              ) : null}
              <div>
                {/* service policy & privacy policy */}
                <ul className="list-unstyled footer-list mt-4">
                  <li className="list-inline-item">
                    {isExternalLegalHref(servicePolicyHref) ? (
                      <a
                        href={servicePolicyHref}
                        target="_blank"
                        rel="noopener noreferrer"
                        className=""
                        style={{ color: "#404040", fontFamily: "Gmarket-M" }}
                      >
                        서비스 이용약관
                      </a>
                    ) : (
                      <Link to={servicePolicyHref} className="" style={{ color: "#404040", fontFamily: "Gmarket-M" }}>
                        서비스 이용약관
                      </Link>
                    )}
                  </li>
                  <li className="list-inline-item">
                    {isExternalLegalHref(privacyPolicyHref) ? (
                      <a
                        href={privacyPolicyHref}
                        target="_blank"
                        rel="noopener noreferrer"
                        className=""
                        style={{ color: "#404040", fontFamily: "Gmarket-M" }}
                      >
                        개인정보처리방침
                      </a>
                    ) : (
                      <Link to={privacyPolicyHref} className="" style={{ color: "#404040", fontFamily: "Gmarket-M" }}>
                        개인정보처리방침
                      </Link>
                    )}
                  </li>
                </ul>
              </div>
            </Col>

            <Col lg={7} className="ms-lg-auto">
              {!!props.permission && props.permission.permission > 0 ? (
                <div style={{ zIndex: "3" }} className="position-absolute top-70 end-10">
                  <Button className="btn-soft-warning me-2" style={{ color: "#404040" }} onClick={() => setVisibleFooterSnsEditModal(!visibleFooterSnsEditModal)}>
                    SNS 수정
                  </Button>
                  <Button className="btn-soft-info" style={{ color: "#404040" }} onClick={() => setVisibleFooterSnsAddModal(!visibleFooterSnsAddModal)}>
                    SNS 추가
                  </Button>
                </div>
              ) : null}
              <Row>
                {/* sns링크가 들어갈 부분 */}
                <div className="text-sm-end mt-3 mt-sm-0">
                  <ul className="list-inline mb-5 footer-social-link">
                    {/* sns링크가 들어갈 부분 */}
                    {snsLinkList.length !== 0 ? (
                      snsLinkList.map((item, idx) => {
                        return (
                          <li key={idx} className="list-inline-item">
                            <a href={item.url} className="avatar-xs d-block">
                              <div className="avatar-title rounded-circle opacity-50 bg-primary p-3">
                                <span className="text-light">
                                  <i className={`ri-${item.sns}-fill ri-2x`} />
                                </span>
                              </div>
                            </a>
                          </li>
                        );
                      })
                    ) : (
                      <div style={{ height: 60 }}></div>
                    )}
                  </ul>
                </div>
              </Row>
            </Col>
          </Row>
        </Container>
      </footer>

      {/* Updating Footer Modal */}
      <FooterModal setVisible={setVisibleFooterEditModal} visible={visibleFooterEditModal} origin={siteInfo.footer} site={siteInfo.id} navigate={navigate} />
      <FooterSnsEditModal setVisible={setVisibleFooterSnsEditModal} visible={visibleFooterSnsEditModal} setSnsList={setSnsLinkList} snsList={snsLinkList} navigate={navigate} />
      <FooterSnsAddModal setVisible={setVisibleFooterSnsAddModal} visible={visibleFooterSnsAddModal} navigate={navigate} />
    </React.Fragment>
  );
};

export default Footer;
